import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const UserInfoApiSlice = createApi({
  reducerPath: "userInfoApi",
  tagTypes: ["userProfile"],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getUserInfo: builder.query({
      query: ({
        email,
        kid
      }: {
        email: string | undefined;
        kid: string | undefined;
      }) => {
        // return {
        //   customuuid: kid,
        //   url: `/utility/users/${email}`,
        //   method: "GET",
        // };
        return {
          url: `/pid/profile/bootstrap/${email}`,
          method: "GET"
        };
      },
      extraOptions: { service: "PID" }
    }),
    getProfileByEmail: builder.query({
      query: ({ email, uid }: { email: string; uid: string }) => ({
        customuuid: uid,
        url: "/graphql",
        body: gql`
          query {
            getProfileByEmail(email: "${email}") {
              version
              timestamp
              error
              data {
                id 
               org
              }
            }
          }
        `
      }),
      extraOptions: {
        service: "PID"
      }
    }),
    getProfileByIdIn: builder.query({
      query: ({ userId }: { userId: string[] }) => ({
        customuuid: userId[0],
        url: "/graphql",
        body: gql`
          query {
            getProfileByIdIn(
              userIds: [
                "${userId}"
              ]
            ) {
              version
              timestamp
              error
              data {
                notAvailable
                profiles {
                  id
                  employeeNumber
                  name {
                    fullName
                    lastName
                    firstName
                  }
                  email
                  profileImageUrl
                  supervisor
                  location {
                    city
                    region
                    country
                    locationName
                    workingLocation
                  }
                  employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }
                  billing {
                    billingBg
                    billingRole
                    billingRoleEndDate
                    billingRoleStartDate
                  }
                  project {
                    projectName
                    projectNumber
                    projectManager
                    allocationEndDate
                    allocationStartDate
                  }
                  enabled
                  org
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "PID" }
    }),
    getUserInfoByUserId: builder.query({
      query: (userId: string) => ({
        customuuid: userId,
        url: "/graphql",
        body: gql`
          query {
            getUserInfoByUserId {
              version
              timestamp
              error
              data {
                id
                userId
                preferences {
                  timezone
                  location
                  language
                  platformPreferences
                }
                goalInformation {
                  objective
                  description
                }
                skillTag {
                  id
                  skillId
                  verifiedby
                  verifiedat
                  proficiency
                  skillTag
                  verificationType
                  source
                }
                summary
                onboarding
                totalExperience
                subscriberIdNovu
                org
              }
            }
          }
        `
      }),
      extraOptions: { service: "Utility" }
    }),
    getUserProfile: builder.query({
      query: ({ uid }: { uid: string }) => {
        {
          return {
            customuuid: uid,
            url: `/utility/profile`,
            method: "GET"
          };
        }
      },
      providesTags: ["userProfile"],
      extraOptions: { service: "Utility" }
    }),
    updateUserProfile: builder.mutation({
      query: ({ uid, body }: any) => {
        {
          return {
            customuuid: uid,
            url: `/utility/profile/uim/update`,
            method: "POST",
            body: body
          };
        }
      },
      invalidatesTags: ["userProfile"],
      extraOptions: { service: "Utility" }
    }),
    getUserTosInfo: builder.query({
      query: ({ uid }: { uid: string }) => {
        {
          return {
            customuuid: uid,
            url: `/utility/tos/version`,
            method: "GET"
          };
        }
      },
      extraOptions: { service: "Utility" }
    }),
    getLatestTosInfo: builder.query({
      query: ({ uid }: { uid: string }) => {
        {
          return {
            customuuid: uid,
            url: `/utility/tos`,
            method: "GET"
          };
        }
      },
      extraOptions: { service: "Utility" }
    }),
    acceptTos: builder.mutation({
      query: ({ version, uid }: { version: string; uid: string }) => {
        {
          return {
            customuuid: uid,
            url: `/utility/tos/accept/${version}`,
            method: "POST"
          };
        }
      },
      extraOptions: { service: "Utility" }
    }),
    updateSkills: builder.mutation({
      query: (body: any) => {
        {
          return {
            url: `/user-skills`,
            method: "POST",
            body: body.body
          };
        }
      },
      extraOptions: { service: "Utility" }
    }),
    getLoginInfo: builder.query({
      query: () => ({
        url: "/login-activity",
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    sendLoginActivity: builder.query({
      query: (activity: any) => ({
        url: `/login-activity/${activity}`,
        method: "post"
      }),
      extraOptions: { service: "Utility" }
    }),
    
  })
});

export const {
  useLazyGetUserInfoQuery,
  useLazyGetUserTosInfoQuery,
  useLazyGetLatestTosInfoQuery,
  useGetLatestTosInfoQuery,
  useAcceptTosMutation,
  useLazyGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useLazyGetProfileByEmailQuery,
  useLazyGetProfileByIdInQuery,
  useLazyGetUserInfoByUserIdQuery,
  useUpdateSkillsMutation,
  useLazyGetLoginInfoQuery,
  useLazySendLoginActivityQuery
} = UserInfoApiSlice;
